/**
 * 每个页面顶部提示 - 跑马灯组件
 * 1. 每次请求都是返回所有页面的 提示信息
 * 2. 每 5分钟重新发起请求.
 * 3. 同一次登录态中, 用户手动关闭提示后， 不再展示提示信息。
 *    用户退出后, 重新登录, 信息也要重新展示.
 */
import React, {useEffect, useState} from "react";
import {Alert, List} from "tea-component";
import {connect, useIntl} from "umi";
import './index.scss';

function MarqueeInfo(props) {
  const {marqueeInfos, pagePath, ...resetProps} = props;
  const [infos, setInfos] = useState<string[]>([]);
  const [visible, setVisible] = useState(false);
  const { locale } = useIntl();
  // 获取pagePath页面的跑马灯提示信息
  const getNoticesText = () => {
    if (!marqueeInfos) return [];
		
    // page字段支持左匹配语法：
    // /overview/daily：具体的path
    // /overview/*：最左匹配
    // *：全部匹配
    const allPaths: string[] = [];
    pagePath.split("/").reduce((acc, param, index, arr) => {
      switch (index) {
        case 0:
          allPaths.push("*");
          return acc;
        case arr.length - 1:
          allPaths.push(`${acc}/${param}`);
          return acc;
        default: {
          acc += `/${  param}`;
          allPaths.push(`${acc  }/*`);
          return acc;
        }
      }
			
    }, "");
		
    const allContents:any[] = [];
    allPaths.forEach(path => {
      if (Array.isArray(marqueeInfos[path]?.contents)) {
        const contents = marqueeInfos[path].contents.map((info) => 
					 (locale === "zh-CN" ? info?.content_cn : info?.content) || info?.content // 如果没有配置content_cn, 无论中英文都是取值content
        ) || [];
        allContents.push(...contents);
      }
    });
    return allContents;
  };
  useEffect(() => {
    const isClose = marqueeInfos[pagePath]?.isClose;
    if (isClose) return;
    const infos = getNoticesText();
    setInfos(infos);
    setVisible(infos.length > 0 && (!isClose));
  }, [pagePath, marqueeInfos, locale]);
  return (<Alert
    type="info"
    visible={visible}
    onClose={() => {
      setVisible(false);
      props.dispatch({type: "dashboard/closeMarqueeInfos", payload: pagePath});
    }}
    hideIcon={infos.length > 1}
    style={{marginBottom: "20px"}}
    {...resetProps}
  >
    {
      infos.length === 1 ? infos[0] :
        (
          <List type="bullet">
            {
              infos?.map((info, index) => (<List.Item className="marqueeInfo-content" key={index}>{info}</List.Item>))
            }
          </List>
        )
			
    }
  </Alert>);
	
}

export default connect(({dashboard}: any) => ({
  marqueeInfos: dashboard.marqueeInfos,
}))(MarqueeInfo);